import { createSlice } from '@reduxjs/toolkit';

export const cpcCard = createSlice({
  name: 'CPC_CARD',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setPreloadStatus(state, action) {
      return {
        ...state,
        preloadStatus: action.payload?.preloadStatus,
      };
    },
    setShowCpcRecommendations(state, action) {
      return {
        ...state,
        showCpcRecommendations: action.payload?.showCpcRecommendations,
      };
    },
    setWasPreviousPageCpcCard(state, action) {
      return {
        ...state,
        wasPreviousPageCpcCard: action.payload?.wasPreviousPageCpcCard,
      };
    },
    setIsNextPageCpcCard(state, action) {
      return {
        ...state,
        isNextPageCpcCard: action.payload?.isNextPageCpcCard,
      };
    },
  },
});

const { actions, reducer } = cpcCard;

export const {
  setPreloadStatus,
  setShowCpcRecommendations,
  setWasPreviousPageCpcCard,
  setIsNextPageCpcCard,
} = actions;

export default reducer;
